import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import { SimpleAudioPlayerComponent } from "../../../../shared/simple-audio-player/simple-audio-player.component";
import {
  AudioClient,
  AgentClient,
  AgentsBasicInfoDto,
  MusicOnHoldClient,
  MusicOnHoldDto,
} from "../../../../System-api";
import { MxCell, MxGraph } from "../../../../@core/model/mxgraph";
import { Subject, Subscription } from "rxjs";
import {
  NbDialogService,
  NbWindowRef,
} from "@nebular/theme";
import { GraphHandlerService } from "../../../../@core/utils/graph.service";
import { SimpleAudioPlayerModalComponent } from "../../../../shared/simple-audio-player-modal/simple-audio-player-modal.component";
import {
  RxFormBuilder,
  RxwebValidators,
} from "@rxweb/reactive-form-validators";
import { UntypedFormGroup } from "@angular/forms";
import { noWhitespaceValidator } from "../../../../@core/utils/helpers";
import { TextToSpeechComponent } from "../../../../shared/text-to-speech/text-to-speech.component";
import { RingGroup } from "../../../../@core/model/ring-group";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { SimpleAgentsModalComponent } from "../../../../shared/simple-agents-modal/simple-agents-modal.component";
import { NbToastrService } from "@nebular/theme";
@Component({
  selector: "ring-group",
  templateUrl: "./ring-group.component.html",
  styleUrls: ["./ring-group.component.scss"],
})
export class RingGroupComponent implements OnInit, OnDestroy {
  @ViewChild("audioPlayer", {
    static: true,
  })
  audioPlayer: SimpleAudioPlayerComponent;

  @ViewChild("textToSpeech", {
    static: true,
  })
  textToSpeech: TextToSpeechComponent;

  @ViewChild("mainMusic", { static: true }) mainMusic: ElementRef;

  options: object[] = [
    { id: 1, name: "Audio From Library" },
    { id: 2, name: "Text To Speech" },
  ];

  errorMessage: string = "Variable is required.";
  cell: MxCell;
  graph: MxGraph;
  data: RingGroup = new RingGroup();
  formGroup: UntypedFormGroup;
  selectedSubscription: Subscription;
  agents: AgentsBasicInfoDto[];
  eventsSubject: Subject<void> = new Subject<void>();

  isLoading = false;
  cancelAction = false;
  selectedMembers: AgentsBasicInfoDto[] = [];

  musicOnHolds: MusicOnHoldDto[] = [];
  mohIdSelected: any = null;
  onInit: boolean = false;
  private maxNotificationRef: any;
  private minNotificationRef: any;

  constructor(
    private dialogService: NbDialogService,
    protected windowRef: NbWindowRef,
    private audioClient: AudioClient,
    private formBuilder: RxFormBuilder,
    private graphService: GraphHandlerService,
    private agentClient: AgentClient,
    private toastrService: NbToastrService,
    private musicOnHoldClient: MusicOnHoldClient
  ) {
    this.data = new RingGroup();
    this.createForm();
  }

  ngOnInit(): void {
    if (this.data.audioId !== "") {
      this.audioClient.get().subscribe((audioVm) => {
        this.audioPlayer.listAudioInAction = audioVm.audios;
        this.audioPlayer.playSelectedAudio(this.data.audioId);
      });
    }

    this.selectedSubscription = this.audioPlayer.selectedAudio.subscribe(
      (audio) => {
        let audioPath = [];
        let audioId = [];
        if (audio) {
          audio.forEach((obj) => {
            audioPath.push(obj.pathAsterisk);
            audioId.push(obj.id);
          });
        }
        this.data.audioId = audio !== undefined ? audioId.toString() : "";
        this.data.audioPath = audio !== undefined ? audioPath.toString() : "";
      }
    );

    this.audioPlayer.showAddButton = true;
    this.audioPlayer.isCallFlowAction = true;

    if (this.data.option !== null) {
      this.handleAudio(Number(this.data.option));
    }

    //set data to data object from cell xml
    for (let [key, value] of Object.entries(this.data)) {
      this.data[key] = this.cell.getAttribute(key);
    }
    if (this.data.isVariable) {
      this.data.isVariable = this.data.isVariable.toString() === "true";
    } else {
      this.data.isVariable = false;
    }
    this.convertToNewDataFormat();
    // map member
    if (this.data.members) {
      const memberExtensions = this.data.members.split(",");
      this.agentClient.getAgentBasicInfoList().subscribe((response) => {
        this.agents = response.agents;
        // Map extensions to agent objects
        this.selectedMembers = memberExtensions
          .map((ext) => this.agents.find((a) => a.extension === ext))
          .filter((agent) => agent !== undefined);
      });
    }
    // TTS
    this.selectedSubscription = this.textToSpeech.selectedTTS.subscribe(
      (tts) => {
        this.data.content = JSON.stringify(tts);
      }
    );
    if (this.data.audioId !== "") {
      this.audioClient.get().subscribe((audioVm) => {
        this.audioPlayer.listAudioInAction = audioVm.audios;
        this.audioPlayer.playSelectedAudio(this.data.audioId);
      });
    }
    if (this.data.option !== null) {
      this.handleAudio(Number(this.data.option));
    }
    if (this.data.content) {
      this.textToSpeech.selectCurrentTTS(this.data.content);
    }

    if (!this.data.ringStrategy) {
      this.data.ringStrategy = "ringall";
    }
    if (!this.data.ringingTime) {
      this.data.ringingTime = "0";
    }

    if (!this.data.musiconhold) {
      this.data.musiconhold = null;
    }

    this.formGroup.patchValue({
      ringStrategy: this.data.ringStrategy,
      ringingTime: this.data.ringingTime,
      musiconhold: this.data.musiconhold,
    });

    // submit
    this.windowRef.onClose.subscribe(() => this.submit());
    this.onInit = true;
    this.getAllMusicOnHold();
  }

  ngOnDestroy() {
    if (this.selectedSubscription) {
      this.selectedSubscription.unsubscribe();
    }
    if (this.maxNotificationRef) {
      this.maxNotificationRef.close();
    }
    if (this.minNotificationRef) {
      this.minNotificationRef.close();
    }
  }
  convertToNewDataFormat() {
    if (!this.data.content) {
      this.data.content = this.data.text;
      this.data.text = "";
    }
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      members: ["", [RxwebValidators.required(), noWhitespaceValidator]],
      ringStrategy: ["ringall", [RxwebValidators.required()]],
      ringingTime: [
        "0",
        [
          RxwebValidators.required(),
          RxwebValidators.numeric(),
          RxwebValidators.minNumber({ value: 0 }),
          RxwebValidators.maxNumber({ value: 300 }),
        ],
      ],
      musiconhold: [""],
    });

    // Subscribe to members changes
    this.formGroup.get("members").valueChanges.subscribe((value) => {
      this.data.members = value; // Cập nhật data.members khi form thay đổi
    });

    // Subscribe to ringStrategy changes
    this.formGroup.get("ringStrategy").valueChanges.subscribe((value) => {
      this.data.ringStrategy = value;
    });

    // Subscribe to ringingTime changes
    this.formGroup.get("ringingTime").valueChanges.subscribe((value) => {
      let numValue = Number(value);
      if (numValue > 300) {
        this.formGroup.patchValue(
          {
            ringingTime: "300",
          },
          { emitEvent: false }
        );
        numValue = 300;

        // Clear existing max notification before showing new one
        if (this.maxNotificationRef) {
          this.maxNotificationRef.close();
        }
        this.maxNotificationRef = this.toastrService.warning(
          "Maximum ring time: 300s",
          "Warning",
          { duration: 3000 }
        );
      } else if (numValue < 0) {
        this.formGroup.patchValue(
          {
            ringingTime: "0",
          },
          { emitEvent: false }
        );
        numValue = 0;

        // Clear existing min notification before showing new one
        if (this.minNotificationRef) {
          this.minNotificationRef.close();
        }
        this.minNotificationRef = this.toastrService.warning(
          "Minimum ring time: 0s",
          "Warning",
          { duration: 3000 }
        );
      }
      this.data.ringingTime = numValue.toString();
    });

    // Subscribe to musiconhold changes
    this.formGroup.get("musiconhold").valueChanges.subscribe((value) => {
      this.data.musiconhold = value;
    });
  }
  showModify() {
    let createAudio = this.dialogService.open(SimpleAudioPlayerModalComponent, {
      autoFocus: false,
      context: {
        showAddButton: true,
        audioListId: this.data.audioId.split(","),
        pendingDeleteAudios: this.audioPlayer.pendingDeleteAudios
      },
    });
    createAudio.componentRef.instance.onAdd.subscribe((rs) => {
      createAudio.close();
      this.eventsSubject.next(rs);
    });
  }
  getVariable($event) {
    this.data.attribute = $event;
  }
  handleAudio(value: number) {
    this.data.option = value;
  }
  handleSaveAction() {
    this.windowRef.close();
  }
  handleCancelAction() {
    this.cancelAction = true;
    this.windowRef.close(true);
  }

  onMemberSelect(event: any) {
    const member = this.agents.find((a) => a.extension === event);
    if (
      member &&
      !this.selectedMembers.find((m) => m.extension === member.extension)
    ) {
      this.selectedMembers.push(member);
      this.updateFormMembers();
    }
  }

  removeMember(member: AgentsBasicInfoDto) {
    this.selectedMembers = this.selectedMembers.filter(
      (m) => m.extension !== member.extension
    );
    this.updateFormMembers();
  }

  drop(event: CdkDragDrop<AgentsBasicInfoDto[]>) {
    moveItemInArray(
      this.selectedMembers,
      event.previousIndex,
      event.currentIndex
    );
    this.updateFormMembers();
  }

  private updateFormMembers() {
    const memberString = this.selectedMembers.map((m) => m.extension).join(",");
    this.formGroup.patchValue({
      members: memberString,
    });
  }

  showAgentSelector() {
    if (this.selectedMembers.length >= 10) {
      this.toastrService.warning("Maximum 10 members allowed", "Warning", {
        duration: 2000,
      });
      return;
    }

    const dialog = this.dialogService.open(SimpleAgentsModalComponent, {
      context: {
        selectedAgents: this.selectedMembers,
      },
      hasBackdrop: true,
      closeOnBackdropClick: false,
      autoFocus: false,
    });

    dialog.componentRef.instance.onSelectAgents.subscribe(
      (agents: AgentsBasicInfoDto[]) => {
        if (agents.length > 10) {
          this.toastrService.warning("Maximum 10 members allowed", "Warning", {
            duration: 2000,
          });
          return;
        }
        this.selectedMembers = agents;
        this.updateFormMembers();
      }
    );
  }

  submit() {
    if (!this.cancelAction && !this.isLoading) {
      for (let [key, value] of Object.entries(this.data)) {
        if (typeof value == "boolean" && value == false) {
          value = "false";
        }
        if (key === "ringingTime") {
          value = value.toString();
        }
        this.cell.setAttribute(key, value || "");
      }
      const ringGroupCell = this.graph.getModel().getCell(this.cell.getId());
      let fieldsRequired = [];
      if (this.data.isVariable == true) {
        fieldsRequired = [this.data.attribute];
      } else {
        fieldsRequired = [this.data.members, this.data.ringStrategy];
      }
      const check = this.graphService.checkIsRequired(
        this.graph,
        fieldsRequired,
        ringGroupCell
      );
      this.cell.setAttribute("checkFields", check?.toString());
    }
  }

  getAllMusicOnHold() {
    this.isLoading = true;
    this.musicOnHoldClient.getAll().subscribe(
      (response) => {
        this.musicOnHolds = [...response.musicOnHoldDtos];
        const defaultValue = new MusicOnHoldDto({ id: 0 });
        this.musicOnHolds.unshift(defaultValue);
        if (this.data?.musiconhold && this.onInit) {
          const selected = this.musicOnHolds.find(m => m.name == this.data.musiconhold);
          this.mohIdSelected = selected?.id || null ;
          this.formGroup.get('musiconhold').setValue(this.data.musiconhold);
          this.onInit = false;
        }
        if (this.data.musiconhold) {
          this.formGroup.patchValue({
            musiconhold: this.data.musiconhold,
          });
        }

        this.isLoading = false;
      },
      (error) => {
        console.error("Error loading music:", error);
        this.isLoading = false;
      }
    );
  }
  handleMohSelect(mohId: number | null) {
    this.mohIdSelected = mohId;
    if (mohId === null) {
      this.data.musiconhold = '';
    } else {
      const selected = this.musicOnHolds.find(m => m.id === mohId);
      this.data.musiconhold = selected?.name || '';
    }
  }
  handleMohRefresh() {
    this.getAllMusicOnHold();
  }
}
